"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _Text = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Text"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _utils = require("../utils");
var _ThemeProvider = require("../ThemeProvider");
var _ViewportProvider = require("../ViewportProvider");
var _Box = _interopRequireDefault(require("../Box"));
var _usePagination = _interopRequireDefault(require("./usePagination"));
var _PageButton = _interopRequireDefault(require("./PageButton"));
var _SideButton = _interopRequireDefault(require("./SideButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);
const selectTextStyles = (_ref, themeOptions) => {
  let {
    color,
    fontName,
    fontSize,
    fontWeight,
    lineHeight
  } = _ref;
  return (0, _ThemeProvider.applyTextStyles)({
    color,
    fontName,
    fontSize,
    fontWeight,
    lineHeight,
    themeOptions
  });
};
const Pagination = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    children,
    copy = 'en',
    variant,
    tokens,
    sideButtonVariant,
    sideButtonTokens,
    LinkRouter,
    linkRouterProps,
    numberOfPagesBeforeEllipsis = 4,
    ...rest
  } = _ref2;
  const viewport = (0, _ViewportProvider.useViewport)();
  const {
    truncateAbove,
    gap,
    ...themeTokens
  } = (0, _ThemeProvider.useThemeTokens)('Pagination', tokens, variant, {
    viewport
  });
  const {
    themeOptions
  } = (0, _ThemeProvider.useTheme)();
  const {
    borderColor,
    borderWidth,
    borderLeftWidth,
    borderRightWidth,
    borderTopWidth,
    borderBottomWidth,
    ellipsisPadding,
    ellipsisBorderRightWidth,
    ellipsisBorderLeftWidth,
    ellipsisBorderTopWidth,
    ellipsisBorderBottomWidth,
    ellipsisHeight
  } = themeTokens;
  const items = _react.default.Children.toArray(children);
  const {
    isItemActive,
    getItemProps,
    showPrevious,
    showNext,
    nextItemProps,
    previousItemProps,
    shouldRenderButton,
    shouldRenderEllipsis
  } = (0, _usePagination.default)({
    items,
    truncateAbove,
    numberOfPagesBeforeEllipsis
  });
  const ellipsisTextStyles = selectTextStyles(themeTokens, themeOptions);
  const ellipisContainerStyles = _StyleSheet.default.create({
    container: {
      height: ellipsisHeight,
      padding: ellipsisPadding,
      borderRightWidth: ellipsisBorderRightWidth,
      borderLeftWidth: ellipsisBorderLeftWidth,
      borderTopWidth: ellipsisBorderTopWidth,
      borderBottomWidth: ellipsisBorderBottomWidth,
      borderColor
    }
  });
  if (items.length === 0) {
    return null;
  }

  // TODO: replace with a spacing component when https://github.com/telus/universal-design-system/pull/531 is implemented
  // concatenate all items to easily wrap them in identical spacing components
  const buttons = [showPrevious && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SideButton.default, {
    ...previousItemProps,
    direction: "previous",
    copy: copy,
    variant: sideButtonVariant,
    tokens: sideButtonTokens,
    LinkRouter: LinkRouter,
    linkRouterProps: linkRouterProps
  }), ...items.map((_child, itemIndex) => {
    const buttonLabel = `${itemIndex + 1}`;
    const itemProps = getItemProps(itemIndex);
    const ItemLinkRouter = itemProps.LinkRouter ?? LinkRouter;
    const itemLinkRouterProps = {
      ...linkRouterProps,
      ...itemProps.linkRouterProps
    };
    if (shouldRenderButton(itemIndex)) {
      return /*#__PURE__*/(0, _react.createElement)(_PageButton.default, {
        ...itemProps,
        LinkRouter: ItemLinkRouter,
        linkRouterProps: itemLinkRouterProps,
        label: buttonLabel,
        copy: copy,
        isActive: isItemActive(itemIndex),
        key: buttonLabel
      });
    }
    if (shouldRenderEllipsis(itemIndex)) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
        style: {
          ...ellipisContainerStyles.container
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          style: {
            ...ellipsisTextStyles
          },
          children: "..."
        })
      }, "...");
    }
    return null;
  }), showNext && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SideButton.default, {
    ...nextItemProps,
    direction: "next",
    copy: copy,
    variant: sideButtonVariant,
    tokens: sideButtonTokens,
    LinkRouter: LinkRouter,
    linkRouterProps: linkRouterProps
  })];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    style: {
      ...staticStyles.container
    },
    ref: ref,
    ...selectProps(rest),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: {
        borderColor,
        borderWidth,
        borderLeftWidth,
        borderRightWidth,
        borderTopWidth,
        borderBottomWidth,
        ...staticStyles.container
      },
      children: buttons
      // keep the keys in-line with the page numbers regardless of which buttons are actually rendered
      .map((element, index) => [element, `page-${index + 1}`]).filter(_ref3 => {
        let [element] = _ref3;
        return element !== null;
      }).map(_ref4 => {
        let [element, key] = _ref4;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          right: gap,
          children: element
        }, key);
      })
    })
  });
});
Pagination.displayName = 'Pagination';
_PageButton.default.displayName = 'PageButton';
Pagination.PageButton = _PageButton.default;
Pagination.propTypes = {
  ...selectedSystemPropTypes,
  ..._utils.withLinkRouter.propTypes,
  children: (0, _utils.componentPropType)('PageButton'),
  /**
   * To change the language for labels
   */
  copy: _utils.copyPropTypes,
  variant: _utils.variantProp.propType,
  tokens: (0, _utils.getTokensPropType)('Pagination'),
  /**
   * When passed as `{{ compact: true }}`, `Pagination` does not render labels along side buttons
   */
  sideButtonVariant: _utils.variantProp.propType,
  /**
   * Custom tokens for `PaginationSideButton`
   */
  sideButtonTokens: (0, _utils.getTokensPropType)('PaginationSideButton'),
  /**
   * The number of pages before the ellipsis is shown
   */
  numberOfPagesBeforeEllipsis: _propTypes.default.number
};
const staticStyles = _StyleSheet.default.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center'
  }
});
var _default = exports.default = Pagination;